import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { GalleryGroup } from 'src/app/Models/gallarygroupmaster';
import { ApiService } from 'src/app/Service/api.service';


@Component({
  selector: 'app-gallarygroupmasters',
  templateUrl: './gallarygroupmasters.component.html',
  styleUrls: ['./gallarygroupmasters.component.css']
})
export class GallarygroupmastersComponent implements OnInit {

  formTitle = "Manage Gallery Albums";
  pageIndex = 1;
  pageSize = 10;
  totalRecords = 1;
  dataList = [];
  loadingRecords = true;
  sortValue: string = "desc";
  sortKey: string = "id";
  searchText: string = "";
  filterQuery: string = "";
  isFilterApplied: string = "default";
   logtext:string = "";
   pageSize2=10

  columns: string[][] =[ ["NAME","Name"],["SEQUENCE_NO","Sequence No"]]

  //drawer Variables
  drawerVisible: boolean;
  drawerTitle: string;
  drawerData: GalleryGroup = new GalleryGroup();
  constructor(private api: ApiService,private message: NzNotificationService) { }
  ngOnInit() {
    this.search();

	this.logtext = 'OPENED - GalleryGroup form KEYWORD[O - GalleryGroup] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });
  }
   // Basic Methods
   sort(sort: { key: string; value: string }): void {
    this.sortKey = sort.key;
    this.sortValue = sort.value;
    this.search(true);
  
  }
  search(reset: boolean = false) {
    if (reset) {
      this.pageIndex = 1;
    }
    this.loadingRecords = true;
    var sort: string;
    try {
      sort = this.sortValue.startsWith("a") ? "asc" : "desc";
	
	this.logtext = 'Filter Applied - GalleryGroup form"+ sort +" "+this.sortKey +" KEYWORD [F - GalleryGroup] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

    } catch (error) {
      sort = "";
    }
    console.log("search text:" + this.searchText);
    if (this.searchText != "") {
      var likeQuery = " AND";
      this.columns.forEach(column => {
        likeQuery += " " + column[0] + " like '%" + this.searchText + "%' OR";
      });
      likeQuery = likeQuery.substring(0, likeQuery.length - 2)
      console.log("likeQuery" + likeQuery);
    }

	this.logtext = 'Filter Applied - GalleryGroup form "+ likeQuery +" KEYWORD [F - GalleryGroup] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

    this.api.getAllGalleryGroup(this.pageIndex, this.pageSize, this.sortKey, sort, likeQuery).subscribe(data => {
      this.loadingRecords = false;
      this.totalRecords = data['count'];
      this.dataList = data['data'];
    }, err => {
      console.log(err);
    });
  }
  //Drawer Methods
  get closeCallback() {
    return this.drawerClose.bind(this);
  }
  add(): void {
    this.drawerTitle = "Create New Gallery Album";
    this.drawerData = new  GalleryGroup();
    this.drawerVisible = true;

	this.logtext = 'ADD - GalleryGroup form KEYWORD [A - GalleryGroup] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //     });

  }
  edit(data:  GalleryGroup): void {

    this.drawerTitle = "Update Gallery Album";
    this.drawerData = Object.assign({}, data);
    this.drawerVisible = true;

	this.logtext = 'EDIT - GalleryGroup form KEYWORD [E - GalleryGroup] ';
	// this.api.addLog('A',this.logtext,this.api.emailId)
  //         .subscribe(successCode => {
  //           if (successCode['code'] == "200") {
  //            console.log(successCode);
  //           }
  //           else {
	// 	console.log(successCode);
  //           }
  //         });


  }
  drawerClose(): void {
    this.search();
    this.drawerVisible = false;
  }

  publish(): void {

    this.api.publish('galleryGroup')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/gallary.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }


  preview(): void {

    this.api.preview('galleryGroup')
      .subscribe(successCode => {
        if (successCode['code'] == "200") {
          this.message.success("Page Published Successfully", "");
          window.open("http://krishnakoyanapatsanstha.com/preview/gallary.html", "_blank");
        }
        else {
          this.message.error("Failed to publish...", "");
        }
      });

  }
}